export class RangeColor {
  color: string;
  range: number;
  rangeLabel: string;

  constructor(init: Partial<RangeColor>) {
    Object.assign(this, init);
  }
}
